import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.company.report');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-company-report',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.company.report/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCompanyReportComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public saving: boolean = false;
    public historyLoading: boolean = false;
    public batchDetailLoading: boolean = false;
    public companies: any[] = [];
    public filteredCompanyRows: any[] = [];
    public visibleCompanyRows: any[] = [];
    public selectedCompanyRows: any[] = [];
    public visibleSelectedCompanyRows: any[] = [];
    public requestBatches: any[] = [];
    public selectedCompanyIds: any = {};
    public selectedCompanyCount: number = 0;
    public filteredCompanyAllSelected: boolean = false;
    public companySearch: string = '';
    public companyPage: number = 1;
    public companyPageSize: number = 50;
    public companyTotal: number = 0;
    public companyHasMore: boolean = false;
    public companyLoadError: string = '';
    public companySearchTimer: any = null;
    public resultOpen: boolean = false;
    public submitResult: any = null;
    public batchDetailOpen: boolean = false;
    public selectedBatch: any = null;

    public requestForm: any = {};
    public requestTypeOptions: any[] = [
        { key: 'quarter_report', label: '분기보고 요청' },
        { key: 'general', label: '별도 요청' }
    ];

    public async ngOnInit() {
        await this.service.init();
        this.resetRequestForm('quarter_report');
        await this.loadCompanies();
        this.loadRequestBatches(true);
    }

    public currentYear(): number {
        return new Date().getFullYear();
    }

    public currentQuarter(): number {
        return Math.floor(new Date().getMonth() / 3) + 1;
    }

    public resetRequestForm(requestType: string = 'quarter_report') {
        const year = this.currentYear();
        const quarter = this.currentQuarter();
        this.requestForm = {
            request_type: requestType,
            company_data_required: requestType === 'quarter_report',
            year,
            quarter,
            title: requestType === 'quarter_report' ? `${year}년 ${quarter}분기 분기보고 요청` : '자료 요청',
            message: '',
            questions: [],
            attachments: []
        };
    }

    public async syncRequestType() {
        const type = this.requestForm.request_type;
        const year = this.requestForm.year || this.currentYear();
        const quarter = this.requestForm.quarter || this.currentQuarter();
        if (type === 'quarter_report') {
            this.requestForm.title = `${year}년 ${quarter}분기 분기보고 요청`;
            this.requestForm.company_data_required = true;
        } else {
            if (!this.requestForm.title || this.requestForm.title.indexOf('분기보고 요청') >= 0) {
                this.requestForm.title = '자료 요청';
            }
            this.requestForm.company_data_required = false;
        }
        await this.service.render();
    }

    public async toggleCompanyDataRequest(event: any) {
        this.requestForm.company_data_required = !!event?.target?.checked;
        await this.service.render();
    }

    public async addQuestion() {
        if (!Array.isArray(this.requestForm.questions)) this.requestForm.questions = [];
        this.requestForm.questions.push({ question: '' });
        await this.service.render();
    }

    public async removeQuestion(index: number) {
        if (!Array.isArray(this.requestForm.questions)) return;
        this.requestForm.questions.splice(index, 1);
        await this.service.render();
    }

    public async loadCompanies() {
        if (this.loading) return;
        this.loading = true;
        this.companyLoadError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load_companies', {
                status: 'investment',
                text: this.companySearch || '',
                page: this.companyPage,
                dump: this.companyPageSize
            });
            if (code === 200) {
                this.companies = data.rows || [];
                this.companyHasMore = !!data.has_more;
                this.companyTotal = data.total || this.companies.length;
                this.filteredCompanyRows = this.companies || [];
                this.visibleCompanyRows = this.filteredCompanyRows;
                this.refreshSelectionState();
            } else {
                this.companyLoadError = data?.message || '기업 목록을 불러오지 못했습니다.';
                this.companyHasMore = false;
            }
        } catch (e) {
            this.companyLoadError = '기업 목록을 불러오지 못했습니다.';
            this.companyHasMore = false;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async resetCompanyList() {
        if (this.loading) return;
        this.companyPage = 1;
        this.companyTotal = 0;
        this.companyHasMore = false;
        this.companyLoadError = '';
        this.companies = [];
        this.filteredCompanyRows = [];
        this.visibleCompanyRows = [];
        await this.loadCompanies();
    }

    public canLoadMoreCompanies(): boolean {
        return !this.loading && this.companyHasMore;
    }

    public async loadMoreCompanies() {
        if (!this.canLoadMoreCompanies()) return;
        const nextPage = this.companyPage + 1;
        this.loading = true;
        this.companyLoadError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load_companies', {
                status: 'investment',
                text: this.companySearch || '',
                page: nextPage,
                dump: this.companyPageSize
            });
            if (code === 200) {
                const seen: any = {};
                this.companyPage = nextPage;
                for (const item of this.companies || []) {
                    if (item.id) seen[item.id] = true;
                }
                for (const item of data.rows || []) {
                    if (item.id && !seen[item.id]) {
                        this.companies.push(item);
                        seen[item.id] = true;
                    }
                }
                this.companyHasMore = !!data.has_more;
                this.companyTotal = data.total || this.companies.length;
                this.filteredCompanyRows = this.companies || [];
                this.visibleCompanyRows = this.filteredCompanyRows;
                this.refreshSelectionState();
            } else {
                this.companyLoadError = data?.message || '기업 목록을 추가로 불러오지 못했습니다.';
                this.companyHasMore = false;
            }
        } catch (e) {
            this.companyLoadError = '기업 목록을 추가로 불러오지 못했습니다.';
            this.companyHasMore = false;
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public filteredCompanies(): any[] {
        return this.filteredCompanyRows || [];
    }

    public applyCompanyFilter() {
        if (this.companySearchTimer) clearTimeout(this.companySearchTimer);
        this.companySearchTimer = setTimeout(async () => {
            await this.resetCompanyList();
        }, 250);
    }

    public refreshSelectionState() {
        const selected = this.selectedCompanyIds || {};
        this.selectedCompanyRows = (this.companies || []).filter((item: any) => selected[item.id]);
        this.visibleSelectedCompanyRows = this.selectedCompanyRows.slice(0, 30);
        this.selectedCompanyCount = this.selectedIds().length;
        const rows = this.filteredCompanyRows || [];
        this.filteredCompanyAllSelected = rows.length > 0 && rows.every((item: any) => this.isSelected(item.id));
    }

    public selectedIds(): string[] {
        return Object.keys(this.selectedCompanyIds).filter((id: string) => this.selectedCompanyIds[id]);
    }

    public selectedCount(): number {
        return this.selectedCompanyCount;
    }

    public isSelected(id: string): boolean {
        return !!this.selectedCompanyIds[id];
    }

    public filteredAllSelected(): boolean {
        return this.filteredCompanyAllSelected;
    }

    public async toggleCompany(id: string, event: any) {
        this.selectedCompanyIds[id] = !!event?.target?.checked;
        this.refreshSelectionState();
        await this.service.render();
    }

    public async toggleFilteredCompanies(event: any) {
        const checked = !!event?.target?.checked;
        for (const item of this.filteredCompanyRows || []) {
            if (item.id) this.selectedCompanyIds[item.id] = checked;
        }
        this.refreshSelectionState();
        await this.service.render();
    }

    public async selectAllCompanies() {
        try {
            const { code, data } = await wiz.call('load_company_ids', {
                status: 'investment',
                text: this.companySearch || ''
            });
            const rows = code === 200 ? (data.rows || []) : (this.companies || []);
            for (const item of rows) {
                if (item.id) this.selectedCompanyIds[item.id] = true;
            }
            if (code !== 200) await this.service.alert.error(data?.message || '전체 기업 선택에 실패했습니다.');
        } catch (e) {
            for (const item of this.companies || []) {
                if (item.id) this.selectedCompanyIds[item.id] = true;
            }
            await this.service.alert.error('전체 기업 선택에 실패해 현재 표시된 기업만 선택했습니다.');
        }
        this.refreshSelectionState();
        await this.service.render();
    }

    public async clearSelection() {
        this.selectedCompanyIds = {};
        this.refreshSelectionState();
        await this.service.render();
    }

    public selectedCompanies(): any[] {
        return this.selectedCompanyRows || [];
    }

    public async addAttachment() {
        if (!Array.isArray(this.requestForm.attachments)) this.requestForm.attachments = [];
        this.requestForm.attachments.push({
            title: '',
            name: '',
            url: '',
            upload_status: 'pending'
        });
        await this.service.render();
    }

    public async uploadAttachment() {
        await this.addAttachment();
    }

    public async uploadAttachmentFile(index: number) {
        if (!Array.isArray(this.requestForm.attachments)) return;
        const attachment = this.requestForm.attachments[index];
        if (!attachment) return;

        const files = await this.service.file.select();
        if (!files || files.length === 0) return;
        const file = files[0];

        await this.service.loading.show();
        try {
            attachment.name = file.name;
            attachment.url = '';
            attachment.upload_status = 'uploading';
            await this.service.render();

            const fd = new FormData();
            fd.append('upload', file);
            try {
                const { url } = await this.service.file.upload('/file/upload?mode=company_request', fd, async () => { });
                attachment.url = url;
                attachment.upload_status = 'uploaded';
            } catch (e) {
                attachment.upload_status = 'failed';
            }
        } finally {
            await this.service.loading.hide();
            await this.service.render();
        }
    }

    public async removeAttachment(index: number) {
        if (!Array.isArray(this.requestForm.attachments)) return;
        this.requestForm.attachments.splice(index, 1);
        await this.service.render();
    }

    public async submitRequest() {
        if (this.saving) return;
        const ids = this.selectedIds();
        if (!this.requestForm.title) {
            await this.service.alert.error('요청 제목을 입력해 주세요.');
            return;
        }
        if (ids.length === 0) {
            await this.service.alert.error('요청할 기업을 선택해 주세요.');
            return;
        }
        const missingAttachmentTitles = (this.requestForm.attachments || []).filter((item: any) => !String(item?.title || '').trim());
        if (missingAttachmentTitles.length > 0) {
            await this.service.alert.error('첨부파일 제목을 입력해 주세요.');
            return;
        }
        const incompleteAttachments = (this.requestForm.attachments || []).filter((item: any) => item.upload_status !== 'uploaded' || !item.url);
        if (incompleteAttachments.length > 0) {
            await this.service.alert.error('업로드가 완료되지 않은 첨부파일이 있습니다.');
            return;
        }

        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call('create_request', {
            company_ids: JSON.stringify(ids),
            request_type: this.requestForm.request_type,
            title: this.requestForm.title,
            message: this.requestForm.message || '',
            year: this.requestForm.year || '',
            quarter: this.requestForm.quarter || '',
            company_data_required: this.requestForm.company_data_required ? 'true' : 'false',
            questions: JSON.stringify(this.requestForm.questions || []),
            attachments: JSON.stringify(this.requestForm.attachments || [])
        });
        this.saving = false;

        if (code !== 200) {
            await this.service.alert.error(data?.message || '요청 등록에 실패했습니다.');
            await this.service.render();
            return;
        }

        this.submitResult = {
            title: this.requestForm.title,
            request_type: this.requestForm.request_type,
            company_count: ids.length,
            rows: data.rows || [],
            quarter_rows: data.quarter_rows || [],
            email: this.emailSummary(data.rows || [])
        };
        this.resultOpen = true;
        await this.service.alert.success(this.requestSuccessMessage(ids.length, this.submitResult.email));
        this.selectedCompanyIds = {};
        this.refreshSelectionState();
        this.resetRequestForm(this.requestForm.request_type);
        await this.resetCompanyList();
        await this.loadRequestBatches(false);
        await this.service.render();
    }

    public async closeResult() {
        this.resultOpen = false;
        await this.service.render();
    }

    public async loadRequestBatches(showLoading: boolean = true) {
        if (showLoading) {
            this.historyLoading = true;
            await this.service.render();
        }
        try {
            const { code, data } = await wiz.call('request_batches', { dump: 500, detail: 'false' });
            if (code === 200) {
                this.requestBatches = data.rows || [];
            }
        } catch (e) {
        } finally {
            this.historyLoading = false;
            await this.service.render();
        }
    }

    public companyTotalText(): string {
        if (this.companyHasMore) return `${this.companies.length}개 이상`;
        return `${this.companyTotal || this.companies.length}개`;
    }

    public companyNames(batch: any): string {
        const names = (batch?.company_preview || batch?.companies || []).map((item: any) => {
            if (typeof item === 'string') return item;
            return item?.name;
        }).filter((name: string) => !!name);
        const total = batch?.company_count || names.length;
        if (total > names.length && names.length > 0) return `${names.slice(0, 3).join(', ')} 외 ${total - names.length}개`;
        if (names.length <= 3) return names.join(', ');
        return `${names.slice(0, 3).join(', ')} 외 ${Math.max(total - 3, 0)}개`;
    }

    public requestPreview(batch: any): string {
        const text = (batch?.message || '').replace(/\s+/g, ' ').trim();
        if (text) return text;
        const attachments = batch?.attachments || [];
        if (attachments.length > 0) return `첨부파일 ${attachments.length}개`;
        return '요청 내용 없음';
    }

    public attachmentCount(batch: any): number {
        return (batch?.attachments || []).length;
    }

    public isQuarterBatch(batch: any): boolean {
        return batch?.request_type === 'quarter_report';
    }

    public showCompanyDataStatus(batch: any): boolean {
        return this.isQuarterBatch(batch) || !!batch?.company_data_required;
    }

    public batchStatusText(batch: any): string {
        if (!batch?.detail_loaded) return `대상 ${batch?.company_count || 0}개 기업`;
        if (!this.showCompanyDataStatus(batch)) return `${batch?.company_count || 0}개 기업`;
        return `요청 ${batch?.company_count || 0}개 · 제출 ${batch?.submitted_company_count || 0}개`;
    }

    public async openBatchDetail(batch: any) {
        this.selectedBatch = batch;
        this.batchDetailOpen = true;
        this.batchDetailLoading = true;
        await this.service.render();
        const { code, data } = await wiz.call('request_batches', {
            dump: 10000,
            batch_id: batch?.id || '',
            detail: 'true'
        });
        this.batchDetailLoading = false;
        if (code === 200 && data?.rows?.length > 0) {
            this.selectedBatch = data.rows[0];
        } else {
            await this.service.alert.error('요청 상세를 불러오지 못했습니다.');
        }
        await this.service.render();
    }

    public async closeBatchDetail() {
        this.batchDetailOpen = false;
        this.selectedBatch = null;
        this.batchDetailLoading = false;
        await this.service.render();
    }

    public selectedBatchCompanies(): any[] {
        return this.selectedBatch?.companies || [];
    }

    public companyLink(company: any): string {
        return `/admin/invest/company/${company?.id}/overview`;
    }

    public emailBadgeClass(status: string = ''): string {
        if (status === 'sent') return 'bg-emerald-50 text-emerald-700';
        if (status === 'partial') return 'bg-amber-50 text-amber-700';
        if (status === 'failed') return 'bg-red-50 text-red-600';
        if (status === 'no_recipient') return 'bg-zinc-100 text-zinc-600';
        return 'bg-zinc-100 text-zinc-500';
    }

    public companyEmailText(company: any): string {
        if (company?.email_status_label) return company.email_status_label;
        return '-';
    }

    public submissionBadgeClass(status: string = ''): string {
        if (status === 'complete') return 'bg-emerald-50 text-emerald-700';
        if (status === 'partial') return 'bg-amber-50 text-amber-700';
        return 'bg-red-50 text-red-600';
    }

    public companySubmissionText(company: any): string {
        return company?.submission_status_label || '미제출';
    }

    public dataStatusLabel(item: any): string {
        if (item?.is_new) return '입력됨';
        return '미입력';
    }

    public dataStatusClass(item: any): string {
        if (item?.is_new) return 'bg-emerald-50 text-emerald-700';
        return 'bg-red-50 text-red-600';
    }

    public companyDocuments(company: any): any[] {
        return company?.data || [];
    }

    public attachmentTitle(file: any): string {
        return file?.title || file?.name || '첨부파일';
    }

    public attachmentStatusText(file: any): string {
        if (file?.upload_status === 'uploaded') return '업로드 완료';
        if (file?.upload_status === 'uploading') return '업로드 중';
        if (file?.upload_status === 'failed') return '업로드 실패';
        return '파일 미선택';
    }

    public attachmentStatusClass(file: any): string {
        if (file?.upload_status === 'uploaded') return 'bg-emerald-50 text-emerald-700';
        if (file?.upload_status === 'failed') return 'bg-red-50 text-red-600';
        return 'bg-amber-50 text-amber-700';
    }

    public dataAttachments(item: any): any[] {
        return item?.attachments || [];
    }

    public submittedAttachments(company: any): any[] {
        return company?.submitted_attachments || [];
    }

    public companySubmittedItems(company: any): string {
        const labels = company?.submitted_item_labels || [];
        if (labels.length === 0) return '-';
        if (labels.length <= 3) return labels.join(', ');
        return `${labels.slice(0, 3).join(', ')} 외 ${labels.length - 3}개`;
    }

    public emailSummary(rows: any[] = []): any {
        const result: any = {
            attempted: 0,
            sent: 0,
            failed: 0,
            no_recipient: 0,
            status: '',
            status_label: ''
        };
        for (const row of rows || []) {
            result.attempted += Number(row.email_attempted_count || 0);
            result.sent += Number(row.email_sent_count || 0);
            result.failed += Number(row.email_failed_count || 0);
            if (row.email_status === 'no_recipient') result.no_recipient += 1;
        }
        if (result.sent > 0 && result.failed === 0 && result.no_recipient === 0) {
            result.status = 'sent';
            result.status_label = '메일 발송 완료';
        } else if (result.sent > 0) {
            result.status = 'partial';
            result.status_label = '메일 일부 실패';
        } else if (result.no_recipient > 0 && result.attempted === 0) {
            result.status = 'no_recipient';
            result.status_label = '회사 인력 이메일 없음';
        } else if (result.failed > 0) {
            result.status = 'failed';
            result.status_label = '메일 발송 실패';
        }
        return result;
    }

    public requestSuccessMessage(count: number, email: any): string {
        let message = `기업 ${count}개에 요청을 등록했습니다.`;
        if (!email?.status_label) return message;
        if (email.sent > 0) return `${message} 메일 ${email.sent}건 발송.`;
        return `${message} ${email.status_label}.`;
    }
}

export default PortalLpsysadminCompanyReportComponent;